import useSWR from 'swr/immutable';
import config from '@packages/config';
import { bucketFetcher, getEndpoint } from '../utils';
import { useCmsFetcherDetails } from './useCmsFetcherDetails';
import type { CmsData } from '../../interfaces/webapp_json';

export const useFooterData = () => {
  const { language, cacheKey } = useCmsFetcherDetails('footer');
  const endpoint = getEndpoint(config.footer.apiEndpoints.bucket, 'footer', language);

  const { data } = useSWR<CmsData>(cacheKey, () => bucketFetcher<CmsData>(endpoint, 240)());

  return data;
};
